import { Role } from "../Controllers/Types/UserRoleInterface";

export const validEmail = (email: string): boolean => {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(String(email).toLowerCase());
};

export const validPassword = (password: string): boolean => {
  // Password must be at least 8 characters long, contain at least one uppercase letter, one lowercase letter, one number, and one special character
  const re =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
  return re.test(password);
};

const validPhoneNumberRegex = (phoneNumber: string): boolean => {
  const regex =
    /^\+?\d{1,4}?[-.\s]?(\(?\d{1,3}?\)?[-.\s]?)?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/;
  return regex.test(phoneNumber);
};

export const validPhoneNumber = (phoneNumber: string): boolean => {
  if (phoneNumber.length < 9 || phoneNumber.length > 18) {
    return false;
  } else if (!validPhoneNumberRegex(phoneNumber)) {
    return false;
  } else {
    return true;
  }
};

export const validMobileNumber = (mobileNumber: string): boolean => {
  if (mobileNumber.length < 9 || mobileNumber.length > 10) {
    return false;
  } else {
    return true;
  }
};

export const validLandlineNumber = (landlineNumber: string): boolean => {
  if (landlineNumber.length < 9 || landlineNumber.length > 10) {
    return false;
  } else {
    return true;
  }
};

export const validateEmail = (email: string): string => {
  if (!email) {
    return "This field is required.";
  } else if (!validEmail(email)) {
    return "Invalid email address.";
  } else {
    return "";
  }
};

export const validateEmailRequired = (
  email: string,
  isRerquired: boolean
): string => {
  if (isRerquired) {
    if (!email) {
      return "This field is required.";
    } else if (!validEmail(email)) {
      return "Invalid email address.";
    } else {
      return "";
    }
  } else {
    if (!email) {
      return "";
    } else {
      if (!validEmail(email)) {
        return "Invalid email address.";
      } else {
        return "";
      }
    }
  }
};

export const validateMobileNoRequired = (
  mobileNo: string,
  isRerquired: boolean
): string => {
  if (isRerquired) {
    if (!mobileNo) {
      return "This field is required.";
    } else if (!validEmail(mobileNo)) {
      return "Invalid phone number address.";
    } else {
      return "";
    }
  } else {
    if (!mobileNo) {
      return "";
    } else {
      if (!validEmail(mobileNo)) {
        return "Invalid phone number address.";
      } else {
        return "";
      }
    }
  }
};

export const validatePasswordRequired = (password: string): string => {
  if (!password) {
    return "This field is required.";
  } else {
    return "";
  }
};

export const validatePassword = (password: string): string => {
  if (!password) {
    return "This field is required.";
  } else if (!validPassword(password)) {
    return "Invalid password.";
  } else {
    return "";
  }
};

export const validateText = (text: string): string => {
  if (!text) {
    return "This field is required.";
  } else {
    return "";
  }
};

export const validateTextRequired = (
  text: string,
  isRerquired: boolean
): string => {
  if (isRerquired) {
    if (!text) {
      return "This field is required.";
    } else {
      return "";
    }
  } else {
    return "";
  }
};

export const validateNumberRequired = (
  number: number,
  isRerquired: boolean
): string => {
  if (isRerquired) {
    if (!number) {
      return "This field is required.";
    } else if (number === 0) {
      return "This field is required.";
    } else {
      return "";
    }
  } else {
    return "";
  }
};

export const validatePercentageRequired = (
  number: number,
  isRerquired: boolean
): string => {
  if (isRerquired) {
    if (number === null) {
      return "This field is required.";
    } else {
      return "";
    }
  } else {
    return "";
  }
};

export const validateAmountNumberRequired = (
  number: number,
  isRerquired: boolean
): string => {
  if (isRerquired) {
    if (number === null) {
      return "This field is required.";
    } else {
      return "";
    }
  } else {
    return "";
  }
};

export const validatePhoneNumber = (phoneNumber: string): string => {
  if (!phoneNumber) {
    return "This field is required.";
  } else if (!validPhoneNumber(phoneNumber)) {
    return "Invalid phone number.";
  } else {
    return "";
  }
};

export const validatePhoneNumberRequired = (
  phoneNumber: string,
  isRerquired: boolean
): string => {
  if (isRerquired) {
    if (!phoneNumber) {
      return "This field is required.";
    } else if (!validPhoneNumber(phoneNumber)) {
      return "Invalid phone number.";
    } else {
      return "";
    }
  } else {
    if (phoneNumber) {
      if (!validPhoneNumber(phoneNumber)) {
        return "Invalid phone number.";
      } else {
        return "";
      }
    } else {
      return "";
    }
  }
};

export const validateFileRequired = (
  file: File,
  isRequired: boolean,
  fileSize: number
) => {
  const MAX_FILE_SIZE = fileSize * 1024 * 1024; // MB to Byte

  if (isRequired) {
    if (file !== null) {
      if (file.size > MAX_FILE_SIZE) {
        return "File size exceeds the maximum limit of " + fileSize + " MB.";
      } else {
        return "";
      }
    } else {
      return "This field is required.";
    }
  } else {
    if (file !== null && file.size > MAX_FILE_SIZE) {
      return "File size exceeds the maximum limit of " + fileSize + " MB.";
    } else {
      return "";
    }
  }
};

export const validateMobileNumber = (mobileNumber: string): string => {
  if (!mobileNumber) {
    return "This field is required.";
  } else if (!validMobileNumber(mobileNumber)) {
    return "Invalid phone number.";
  } else {
    return "";
  }
};

export const validateLandlineNumber = (landlineNumber: string): string => {
  if (!landlineNumber) {
    return "This field is required.";
  } else if (!validLandlineNumber(landlineNumber)) {
    return "Invalid phone number.";
  } else {
    return "";
  }
};

export const checkText = (
  text: string,
  isRequired: boolean,
  setError: (error: string) => void
): boolean => {
  const error = validateTextRequired(text, isRequired);
  if (error === "") {
    setError("");
    return true;
  } else {
    setError(error);
    return false;
  }
};

export const checkEmail = (
  email: string,
  isRequired: boolean,
  setEmailError: (error: string) => void
): boolean => {
  const error = validateEmailRequired(email, isRequired);
  if (error === "") {
    setEmailError("");
    return true;
  } else {
    setEmailError(error);
    return false;
  }
};

export const checkPhoneNumber = (
  number: string,
  isRequired: boolean,
  setError: (error: string) => void
): boolean => {
  const error = validatePhoneNumberRequired(number, isRequired);
  if (error === "") {
    setError("");
    return true;
  } else {
    setError(error);
    return false;
  }
};

export const checkMobileNumber = (
  number: string,
  isRequired: boolean,
  setError: (error: string) => void
): boolean => {
  const error = validatePhoneNumberRequired(number, isRequired);
  if (error === "") {
    setError("");
    return true;
  } else {
    setError(error);
    return false;
  }
};

export const checkRole = (
  role: Role,
  isRequired: boolean,
  setError: (error: string) => void
): boolean => {
  if (role && role?.id !== 0) {
    setError("");
    return true;
  } else {
    setError(validateTextRequired("", isRequired));
    return false;
  }
};

export const checkPassword = (
  password: string,
  isRequired: boolean,
  setError: (error: string) => void
): boolean => {
  if (isRequired) {
    const error = validatePassword(password);
    if (error === "") {
      setError("");
      return true;
    } else {
      setError(error);
      return false;
    }
  } else {
    setError("");
    return true;
  }
};

export const checkConfirmPassword = (
  confirmPassword: string,
  password: string,
  isRequired: boolean,
  setError: (error: string) => void
): boolean => {
  if (isRequired) {
    const error = validatePasswordRequired(confirmPassword);
    if (error === "") {
      if (confirmPassword === password) {
        setError("");
        return true;
      } else {
        setError("Password confirmation does not match the password.");
        return false;
      }
    } else {
      setError(error);
      return false;
    }
  } else {
    setError("");
    return true;
  }
};

export const checkFileImage = (
  file: File,
  isRequired: boolean,
  setError: (error: string) => void
): boolean => {
  const error = validateFileRequired(file, isRequired, 2);

  if (error === "") {
    setError("");
    return true;
  } else {
    setError(error);
    return false;
  }
};

export const checkFileOthers = (
  file: File,
  isRequired: boolean,
  setError: (error: string) => void
): boolean => {
  const error = validateFileRequired(file, isRequired, 50);

  if (error === "") {
    setError("");
    return true;
  } else {
    setError(error);
    return false;
  }
};

export const checkFileOtherList = (
  file: File[],
  isRequired: boolean,
  setError: (error: string) => void
): boolean => {
  if (isRequired && file.length === 0) {
    setError("File is empty!");
    return false;
  } else {
    file.forEach((oneFile) => {
      const error = validateFileRequired(oneFile, isRequired, 10);
      if (error === "") {
        setError("");
        return true;
      } else {
        setError(error);
        return false;
      }
    });
    setError("");
    return true;
  }
};

export const checkNumber = (
  number: number,
  isRequired: boolean,
  setError: (error: string) => void
): boolean => {
  const error = validateNumberRequired(number, isRequired);
  if (error === "") {
    setError("");
    return true;
  } else {
    setError(error);
    return false;
  }
};

export const checkPercentage = (
  number: number,
  isRequired: boolean,
  setError: (error: string) => void
): boolean => {
  const error = validatePercentageRequired(number, isRequired);
  if (error === "") {
    setError("");
    return true;
  } else {
    setError(error);
    return false;
  }
};

export const checkNumberForAmount = (
  number: number,
  isRequired: boolean,
  setError: (error: string) => void
): boolean => {
  const error = validateAmountNumberRequired(number, isRequired);
  if (error === "") {
    setError("");
    return true;
  } else {
    setError(error);
    return false;
  }
};

export const checkNumberForProgramme = (
  number: number,
  isRequired: boolean,
  setError: (error: string) => void
): boolean => {
  if (isRequired) {
    if (!number) {
      setError("Please enter a valid value.");
      return false;
    } else {
      setError("");
      return true;
    }
  } else {
    setError("");
    return true;
  }
};

export const getNonNullValue = (value: any, defaultValue = "") =>
  value || defaultValue;

export const checkModelSelected = (
  selected: boolean,
  isRequired: boolean,
  setError: (error: string) => void
): boolean => {
  let error = "";

  if (isRequired) {
    if (selected === false) {
      error = "This field is required!";
    }
  }

  if (error === "") {
    setError("");
    return true;
  } else {
    setError(error);
    return false;
  }
};
